import React, { Component } from 'react';
import DrawableCanvas from './drawable.js';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import HomeButtons from '../../components/homeButtons/';
import Footer from '../../components/footer/';
import {
  welcome,
  blooddrive,impact,dam,reclaimed,lift,harbor,foundation,diner,forge,theslab,oldtown,
  inferno,train,mirage,nuke,cobblestone,overpass,cache,
  promenade,redfalls,reactor,station,trench,vertigo,grandview,mammoth,
  soccer,football,basketball,baseball,hockey,
  bank1,bank2,bank3,bank4,clubhouse1,clubhouse2,clubhouse3,clubhouse4,
  asylum,bunker,district,exhibit,icebound,traininggrounds,vasgar,
  bind,haven,split,ascent,
  canals, favelas, skyfell, windward, icarus, vice, highcastle, factory
} from '../../utils/maps/image_paths.jsx';
var c;
var ctx;
const Home = React.createClass({

  componentDidUpdate() {
         var {overlay, canvas, currentUser} = this.props;
         let c = ReactDOM.findDOMNode(this.refs.myCanvas);
         let ctx = c.getContext('2d');
          var count = canvas.history.length - 1;
          if (count == -1)
          {
            ctx.clearRect(0,0,c.width,c.height);
            return;
          }
          var idt = canvas.history[count];
          ctx.putImageData(idt, 0, 0);
     },

    render() {
      var data = {
        TRICKSTRATWELCOME: welcome,
        GEARS4IMPACT: impact,GEARS4BLOODDRIVE: blooddrive,GEARS4DAM: dam,GEARS4RECLAIMED: reclaimed,GEARS4LIFT: lift,GEARS4HARBOR: harbor,GEARS4FOUNDATION: foundation,GEARS4DINER: diner,GEARS4FORGE: forge,GEARS4THESLAB: theslab, GEARS4OLDTOWN: oldtown,
        CSGOINFERNO: inferno,CSGOTRAIN: train,CSGOMIRAGE: mirage,CSGONUKE: nuke,CSGOCOBBLESTONE: cobblestone,CSGOOVERPASS: overpass,CSGOCACHE: cache,
        LAWBREAKERSPROMENADE: promenade, LAWBREAKERSREDFALLS: redfalls, LAWBREAKERSREACTOR: reactor, LAWBREAKERSSTATION: station, LAWBREAKERSTRENCH: trench, LAWBREAKERSVERTIGO: vertigo, LAWBREAKERSGRANDVIEW: grandview, LAWBREAKERSMAMMOTH: mammoth,
        SPORTSSOCCER: soccer,SPORTSFOOTBALL: football,SPORTSBASKETBALL: basketball,SPORTSBASEBALL: baseball,SPORTSHOCKEY: hockey,
        RS6BANK1: bank1, RS6BANK2: bank2, RS6BANK3: bank3, RS6BANK4: bank4, RS6CLUBHOUSE1: clubhouse1, RS6CLUBHOUSE2: clubhouse2, RS6CLUBHOUSE3: clubhouse3, RS6CLUBHOUSE4: clubhouse4,
        GEARS5ASYLUM: asylum, GEARS5BUNKER: bunker, GEARS5DAM: dam, GEARS5DISTRICT: district, GEARS5EXHIBIT: exhibit, GEARS5FORGE: forge,GEARS5FOUNDATION: foundation,GEARS5HARBOR: harbor, GEARS5TRAININGGROUNDS: traininggrounds,GEARS5ICEBOUND: icebound,GEARS5RECLAIMED: reclaimed, GEARS5VASGAR: vasgar,
        VALORANTBIND: bind, VALORANTHAVEN: haven, VALORANTSPLIT: split, VALORANTASCENT: ascent,
        ROGUECOMPANYCANALS: canals, ROGUECOMPANYFAVELAS: favelas, ROGUECOMPANYSKYFELL: skyfell, ROGUECOMPANYWINDWARD: windward, ROGUECOMPANYICARUS: icarus, ROGUECOMPANYVICE: vice, ROGUECOMPANYHIGHCASTLE: highcastle, ROGUECOMPANYFACTORY: factory
      };

            //console.log(this.props);
            var {map, overlay, canvas, currentUser, userData, active} = this.props;
            var bg = null;
            var strat = null;
            if (map != null) {
              //bg = './images/' + map.game + '/' + map.map + '.jpg';
              bg = data[map.game+map.map];
            }

            if (active.stratId != null && userData.data != null)
            {
              if (userData.data.strats[active.stratId] != null)
              {
                if (userData.data.strats[active.stratId].canvas != null)
                {
               strat = userData.data.strats[active.stratId].canvas;
                }
              }
              //console.log(src);
              //var strat     = document.createElement('img'); // create a Image Element
              //strat.src     = src;   //image source
            }


      var canvasProps = {
        brushColor: overlay.color,
        lineWidth: 2.5,
        canvasStyle: {
            backgroundImage: 'url(' + strat + '),url('+ bg + ')',
            backgroundSize: '100% auto',
            backgroundRepeat: 'no-repeat',
            cursor: 'pointer',
            height: '720',
            width:'1400',
              maxWidth: '100%'
        },
        clear: overlay.clear,
        ref: "myCanvas"
      }
        return (
          <div>
            {/*}<button  onClick={(event) => {this.undo();}}>Undo</button>
            <button  onClick={(event) => {this.redo();}}>Redo</button>
            <br/>*/}
          <HomeButtons/>

            <div
            ref='board'
            className='editor-drawingboard'
            >
            <DrawableCanvas {...canvasProps} />
            </div>
            <Footer/>
          </div>
        );
    },

});

module.exports = connect((state) => {
    return {
      color: state.color, overlay: state.overlay, map: state.map, canvas: state.canvas, currentUser: state.currentUser, userData: state.userData, active: state.active
    }
})(Home);



// WEBPACK FOOTER //
// ./src/app/containers/landing/index.jsx